<div class="input search-input">
  <div class="input-wrapper">
    <img src="../../../../../assets/icons/search-icon.png" />
    <input type="search" placeholder="Buscar otras icudades" />
  </div>
</div>
